// extracted by mini-css-extract-plugin
module.exports = {"_pill-style":"PillStyle__pill-style_2xV0d b--white ba fw6"};